// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic_Cart_Detail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic_Cart_ExtraDiscount from "../Restaumatic.Cart.ExtraDiscount/index.js";
import * as Restaumatic_Cart_Pricing from "../Restaumatic.Cart.Pricing/index.js";
import * as Restaumatic_Cart_ProductItem from "../Restaumatic.Cart.ProductItem/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Cart_PromotionData from "../Restaumatic.Cart.PromotionData/index.js";
import * as Restaumatic_Cart_PromotionalItem from "../Restaumatic.Cart.PromotionalItem/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Menu_V2_Env from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic_Menu_V2_Packaging from "../Restaumatic.Menu.V2.Packaging/index.js";
import * as Restaumatic_Menu_V2_Packaging_MinNumberOfContainersHeuristicAlgo from "../Restaumatic.Menu.V2.Packaging.MinNumberOfContainersHeuristicAlgo/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_ItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Restaumatic_Orders_Checkout_Types_ExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_Types from "../Restaumatic.PromotionsEngine.Cart.Types/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
import * as Restaumatic_PromotionsEngine_Tools_Assignment from "../Restaumatic.PromotionsEngine.Tools.Assignment/index.js";
import * as Restaumatic_PromotionsEngine_Tools_CartEvaluation from "../Restaumatic.PromotionsEngine.Tools.CartEvaluation/index.js";
import * as Restaumatic_PromotionsEngine_Tools_Distribution from "../Restaumatic.PromotionsEngine.Tools.Distribution/index.js";
import * as Restaumatic_PromotionsEngine_Tools_Filter from "../Restaumatic.PromotionsEngine.Tools.Filter/index.js";
import * as Restaumatic_PromotionsEngine_Tools_PromotionEvaluation from "../Restaumatic.PromotionsEngine.Tools.PromotionEvaluation/index.js";
import * as Restaumatic_PromotionsEngine_Tools_UserAction from "../Restaumatic.PromotionsEngine.Tools.UserAction/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
var First = /* #__PURE__ */ (function () {
    function First() {

    };
    First.value = new First();
    return First;
})();
var Last = /* #__PURE__ */ (function () {
    function Last() {

    };
    Last.value = new Last();
    return Last;
})();
var Cart = function (x) {
    return x;
};
var ModifyQuantity = /* #__PURE__ */ (function () {
    function ModifyQuantity(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ModifyQuantity.create = function (value0) {
        return function (value1) {
            return new ModifyQuantity(value0, value1);
        };
    };
    return ModifyQuantity;
})();
var ReplaceItem = /* #__PURE__ */ (function () {
    function ReplaceItem(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ReplaceItem.create = function (value0) {
        return function (value1) {
            return new ReplaceItem(value0, value1);
        };
    };
    return ReplaceItem;
})();
var SetPromotionalItemSelected = /* #__PURE__ */ (function () {
    function SetPromotionalItemSelected(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetPromotionalItemSelected.create = function (value0) {
        return function (value1) {
            return new SetPromotionalItemSelected(value0, value1);
        };
    };
    return SetPromotionalItemSelected;
})();
var ChangePromotionalItemInput = /* #__PURE__ */ (function () {
    function ChangePromotionalItemInput(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ChangePromotionalItemInput.create = function (value0) {
        return function (value1) {
            return new ChangePromotionalItemInput(value0, value1);
        };
    };
    return ChangePromotionalItemInput;
})();
var DisablePromotionalItemSelection = /* #__PURE__ */ (function () {
    function DisablePromotionalItemSelection(value0) {
        this.value0 = value0;
    };
    DisablePromotionalItemSelection.create = function (value0) {
        return new DisablePromotionalItemSelection(value0);
    };
    return DisablePromotionalItemSelection;
})();
var ModifyCouponCode = /* #__PURE__ */ (function () {
    function ModifyCouponCode(value0) {
        this.value0 = value0;
    };
    ModifyCouponCode.create = function (value0) {
        return new ModifyCouponCode(value0);
    };
    return ModifyCouponCode;
})();
var RecalculatePromotions = /* #__PURE__ */ (function () {
    function RecalculatePromotions() {

    };
    RecalculatePromotions.value = new RecalculatePromotions();
    return RecalculatePromotions;
})();
var RecalculateProductDetails = /* #__PURE__ */ (function () {
    function RecalculateProductDetails() {

    };
    RecalculateProductDetails.value = new RecalculateProductDetails();
    return RecalculateProductDetails;
})();
var toPromotionalItems = function (menu) {
    return function (cartData) {
        return function (items) {
            var toPromotionalItem = function (item) {
                return Data_Either.hush(Restaumatic_Menu_Query.runMenuQuery(menu)((function () {
                    var id = Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId(item);
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPromotion(id))(function (promotion) {
                        return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Cart_PromotionData.promotionDetails(id))(function (details) {
                            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                                engineItem: item,
                                details: details,
                                promotion: promotion
                            });
                        });
                    });
                })()));
            };
            return Data_Array.mapMaybe(toPromotionalItem)(Restaumatic_PromotionsEngine_Tools_PromotionEvaluation.evaluateEnabledPromotionalItems(Restaumatic_Cart_ProductKey.eqProductKey)(cartData)(items));
        };
    };
};
var takeByKey = function (dictOrd) {
    return function (k) {
        return function (acc) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Map_Internal.lookup(dictOrd)(k)(acc))(function (xs) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.uncons(xs))(function (v) {
                    return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                        value: v.head,
                        accum: Data_Map_Internal.insert(dictOrd)(k)(v.tail)(acc)
                    });
                });
            });
        };
    };
};
var setPromotionalItems = function (items) {
    return function (v) {
        return {
            products: v.products,
            promotionalItems: items,
            couponCode: v.couponCode,
            extraDiscount: v.extraDiscount,
            packagingContainers: v.packagingContainers,
            packagingContainersCost: v.packagingContainersCost
        };
    };
};
var setExtraDiscount = function (d) {
    return function (v) {
        return {
            products: v.products,
            promotionalItems: v.promotionalItems,
            couponCode: v.couponCode,
            extraDiscount: d,
            packagingContainers: v.packagingContainers,
            packagingContainersCost: v.packagingContainersCost
        };
    };
};
var promotionsEngineItem = function (v) {
    return v.engineItem;
};
var promotionalItems = function (v) {
    return v.promotionalItems;
};
var promotionsTotal = /* #__PURE__ */ (function () {
    var $287 = Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney);
    var $288 = Data_Functor.map(Data_Functor.functorArray)(Restaumatic_Cart_PromotionalItem.promotionalItemPrice);
    return function ($289) {
        return $287($288(promotionalItems($289)));
    };
})();
var productItems = function (v) {
    return v.products;
};
var toInputCartData = function (assignmentMode) {
    return function (cart) {
        var convertProductItem = function (v) {
            var unwrapMapElem = function (v1) {
                return new Data_Tuple.Tuple(Data_Newtype.unwrap()(v1.value0), Data_Newtype.unwrap()(v1.value1));
            };
            var mkEngineItemId = function (v1) {
                if (v1 instanceof Restaumatic_Menu_V2_Types_ItemId.ProductItem) {
                    return Restaumatic_UnwrapOperators.applyUnwrapped()(Restaumatic_PromotionsEngine_Cart_Types.ProductItem.create)(v1.value0);
                };
                if (v1 instanceof Restaumatic_Menu_V2_Types_ItemId.ComboItem) {
                    return Restaumatic_UnwrapOperators.applyUnwrapped()(Restaumatic_PromotionsEngine_Cart_Types.ComboItem.create)(v1.value0);
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 355, column 5 - line 355, column 81): " + [ v1.constructor.name ]);
            };
            var template = function (unitPrice1) {
                return {
                    productName: "",
                    productPrice: unitPrice1,
                    productId: (function () {
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Pizza && v.key.value0.def instanceof Restaumatic_Cart_ProductKey.StandardPizza) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductPizza.value)(v.key.value0.def.value0);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Pizza && v.key.value0.def instanceof Restaumatic_Cart_ProductKey.CustomPizza) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductPizza.value)(v.key.value0.def.value0.basePizzaId);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Dish) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductDish.value)(v.key.value0.id);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Drink) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductDrink.value)(v.key.value0.id);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.SplitPizza) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkGenericProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductPizza.value);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.CustomProduct) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkGenericProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductDish.value);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkGenericProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductPizza.value);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
                            return Restaumatic_PromotionsEngine_Cart_ProductItem.mkGenericProductId(Restaumatic_PromotionsEngine_Cart_ProductItem.ProductPizza.value);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 308, column 11 - line 316, column 59): " + [ v.key.constructor.name ]);
                    })(),
                    productSize: (function () {
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Pizza) {
                            return new Data_Maybe.Just(v.key.value0.size);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Dish) {
                            return Data_Maybe.Nothing.value;
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.Drink) {
                            return new Data_Maybe.Just(v.key.value0.size);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.SplitPizza) {
                            return new Data_Maybe.Just(v.key.value0.size);
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.CustomProduct) {
                            return Data_Maybe.Nothing.value;
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
                            return Data_Maybe.Nothing.value;
                        };
                        if (v.key instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
                            return Data_Maybe.Nothing.value;
                        };
                        throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 318, column 11 - line 325, column 35): " + [ v.key.constructor.name ]);
                    })(),
                    dishGroupId: (function () {
                        if (v.details instanceof Data_Maybe.Just && v.details.value0 instanceof Restaumatic_Cart_Detail.DishDetails) {
                            return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Newtype.unwrap())(v.details.value0.value0.dishGroupId);
                        };
                        return Data_Maybe.Nothing.value;
                    })(),
                    productCategoryId: (function () {
                        if (v.details instanceof Data_Maybe.Just && v.details.value0 instanceof Restaumatic_Cart_Detail.MenuProductDetails) {
                            return Restaumatic_UnwrapOperators.applyUnwrapped()(Data_Maybe.Just.create)(v.details.value0.value0.productCategoryId);
                        };
                        return Data_Maybe.Nothing.value;
                    })(),
                    itemId: (function () {
                        if (v.details instanceof Data_Maybe.Just && v.details.value0 instanceof Restaumatic_Cart_Detail.MenuProductDetails) {
                            return new Data_Maybe.Just(mkEngineItemId(v.details.value0.value0.itemId));
                        };
                        if (v.details instanceof Data_Maybe.Just && v.details.value0 instanceof Restaumatic_Cart_Detail.MenuComboDetails) {
                            var v1 = Data_Array.head(v.details.value0.value0);
                            if (v1 instanceof Data_Maybe.Just) {
                                return new Data_Maybe.Just(mkEngineItemId(v1.value0.itemId));
                            };
                            return Data_Maybe.Nothing.value;
                        };
                        return Data_Maybe.Nothing.value;
                    })(),
                    customParameters: (function () {
                        if (v.details instanceof Data_Maybe.Just && v.details.value0 instanceof Restaumatic_Cart_Detail.MenuProductDetails) {
                            var paramTuples = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(v.details.value0.value0.customParametersMap);
                            return Data_Map_Internal.fromFoldable(Data_UUID.ordUUID)(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(unwrapMapElem)(paramTuples));
                        };
                        return Data_Map_Internal.empty;
                    })(),
                    isCombo: (function () {
                        if (v.details instanceof Data_Maybe.Just && v.details.value0 instanceof Restaumatic_Cart_Detail.MenuComboDetails) {
                            return true;
                        };
                        return false;
                    })()
                };
            };
            if (v.unitPrice instanceof Data_Maybe.Just) {
                return Restaumatic_PromotionsEngine_Cart_ProductItem.mkProductItems(template(v.unitPrice.value0))(v.key)(v.quantity);
            };
            if (v.unitPrice instanceof Data_Maybe.Nothing) {
                return [  ];
            };
            throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 300, column 5 - line 302, column 20): " + [ v.unitPrice.constructor.name ]);
        };
        return {
            productItems: Data_Array.concatMap(convertProductItem)(productItems(cart)),
            orderType: Restaumatic_PromotionsEngine_Cart_CartParams.Delivery.value,
            deliveryZone: Restaumatic_PromotionsEngine_Cart_CartParams.defaultDeliveryZone,
            requestedTime: Restaumatic_PromotionsEngine_Cart_CartParams.Asap.value,
            assignmentMode: assignmentMode
        };
    };
};
var totalAfterPromotions = function (cart) {
    return Data_Numeric.add(Data_Money_Rounded.additiveMoney)(Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Money_Rounded.additiveMoney)(Data_Functor.map(Data_Functor.functorArray)((function () {
        var $290 = Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney));
        return function ($291) {
            return $290(Restaumatic_Cart_ProductItem.productItemPrice($291));
        };
    })())(productItems(cart))))(promotionsTotal(cart));
};
var packageProductItems = function (menu) {
    return function (items) {
        var productCategories = Data_Newtype.unwrap()((Data_Newtype.unwrap()((Data_Newtype.unwrap()(menu)).catalogue)).categories);
        var productCatalogue = Data_Newtype.unwrap()((Data_Newtype.unwrap()((Data_Newtype.unwrap()(menu)).catalogue)).products);
        var packagingContainersCatalogue = Data_Newtype.unwrap()((Data_Newtype.unwrap()((Data_Newtype.unwrap()(menu)).catalogue)).packagingContainers);
        var modifiersCatalogue = Data_Newtype.unwrap()((Data_Newtype.unwrap()((Data_Newtype.unwrap()(menu)).catalogue)).modifiers);
        var combosCatalogue = Data_Newtype.unwrap()((Data_Newtype.unwrap()((Data_Newtype.unwrap()(menu)).catalogue)).combos);
        var comboProductKeyProductsAndModifiers = function (v) {
            var v1 = Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.elements));
            var v2 = Data_Functor.map(Data_Functor.functorArray)(function (v3) {
                var v4 = Control_Bind.bind(Control_Bind.bindArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Functor.map(Data_Map_Internal.functorMap)(Data_Newtype.unwrap())(Data_Newtype.unwrap()(v3.value1.modifiers))))(function (v5) {
                    return Data_Functor.map(Data_Functor.functorArray)(function (modItemId) {
                        return {
                            modifier: v5.value0,
                            modifierItem: modItemId
                        };
                    })(Data_MultiSet.elems(v5.value1));
                });
                var mcombo = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v.comboId)(combosCatalogue);
                var mcomboElement = Control_Bind.bind(Data_Maybe.bindMaybe)(mcombo)((function () {
                    var $292 = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v3.value0);
                    var $293 = Data_Newtype.unwrap();
                    return function ($294) {
                        return $292(Data_Map_Ordered.toMap((function (v5) {
                            return v5.elements;
                        })($293($294))));
                    };
                })());
                var mchoice = Control_Bind.bind(Data_Maybe.bindMaybe)(mcomboElement)((function () {
                    var $295 = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(v3.value1.comboChoiceId);
                    var $296 = Data_Newtype.unwrap();
                    return function ($297) {
                        return $295(Data_Map_Ordered.toMap((function (v5) {
                            return v5.choices;
                        })($296($297))));
                    };
                })());
                var mproductId = Data_Functor.map(Data_Maybe.functorMaybe)((function () {
                    var $298 = Data_Newtype.unwrap();
                    return function ($299) {
                        return (function (v5) {
                            return v5.product;
                        })($298($299));
                    };
                })())(mchoice);
                return new Data_Tuple.Tuple(v4, mproductId);
            })(v1);
            return {
                products: Data_Array.mapMaybe(Control_Category.identity(Control_Category.categoryFn))(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(v2)),
                modifiers: Control_Bind.bind(Control_Bind.bindArray)(v2)(Data_Tuple.fst)
            };
        };
        var cartProductKeyProductsAndModifiers = function (v) {
            var cartProductKeyPartProductsAndModifiers = function (v1) {
                return new Data_Tuple.Tuple(v1.productId, Control_Bind.bind(Control_Bind.bindArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Functor.map(Data_Map_Internal.functorMap)(Data_Newtype.unwrap())(Data_Newtype.unwrap()(v1.modifiers))))(function (v2) {
                    return Data_Functor.map(Data_Functor.functorArray)(function (modItemId) {
                        return {
                            modifier: v2.value0,
                            modifierItem: modItemId
                        };
                    })(Data_MultiSet.elems(v2.value1));
                }));
            };
            var productsAndModifiers = Data_Functor.map(Data_Functor.functorArray)(cartProductKeyPartProductsAndModifiers)(Data_Array_NonEmpty.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_Newtype.unwrap()(v.parts)));
            return {
                products: Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(productsAndModifiers),
                modifiers: Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd)(productsAndModifiers))
            };
        };
        var cartPackagedItems = function (products) {
            return Control_Bind.bind(Control_Bind.bindArray)(products)(function (v) {
                if (v.key instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
                    return Data_Array.replicate(v.quantity)(cartProductKeyProductsAndModifiers(v.key.value0));
                };
                if (v.key instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
                    return Data_Array.replicate(v.quantity)(comboProductKeyProductsAndModifiers(v.key.value0));
                };
                return [  ];
            });
        };
        return Restaumatic_Menu_V2_Packaging.computePackagingContainers(productCategories)(packagingContainersCatalogue)(productCatalogue)(modifiersCatalogue)(function (dictOrd) {
            return Restaumatic_Menu_V2_Packaging_MinNumberOfContainersHeuristicAlgo.minNumberOfContainersHeuristic(dictOrd);
        })(cartPackagedItems(items));
    };
};
var normalizeProductKey = function ($copy_key) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(key) {
        var normalizePizzaDef = function (v) {
            if (v instanceof Restaumatic_Cart_ProductKey.CustomPizza) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Menu_Query.findPizza(v.value0.basePizzaId))(function (v1) {
                    var $184 = Data_Eq.eq(Data_MultiSet.eqMultiSet(Restaumatic_Menu_Types_Id.eqToppingId))(Data_OrderedMultiSet.toMultiSet(Restaumatic_Menu_Types_Id.ordToppingId)(v1.toppings))(v.value0.toppings);
                    if ($184) {
                        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(new Restaumatic_Cart_ProductKey.StandardPizza(v.value0.basePizzaId));
                    };
                    return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(v);
                });
            };
            return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(v);
        };
        if (key instanceof Restaumatic_Cart_ProductKey.Pizza) {
            $tco_done = true;
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(normalizePizzaDef(key.value0.def))(function (def) {
                return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(new Restaumatic_Cart_ProductKey.Pizza({
                    def: def,
                    size: key.value0.size,
                    panType: key.value0.panType
                }));
            });
        };
        if (key instanceof Restaumatic_Cart_ProductKey.SplitPizza && key.value0.parts.length === 1) {
            $copy_key = new Restaumatic_Cart_ProductKey.Pizza({
                def: key["value0"]["parts"][0],
                panType: key.value0.panType,
                size: key.value0.size
            });
            return;
        };
        if (key instanceof Restaumatic_Cart_ProductKey.SplitPizza) {
            $tco_done = true;
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Restaumatic_Menu_Query.applicativeMenuQuery)(normalizePizzaDef)(key.value0.parts))(function (parts) {
                return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(new Restaumatic_Cart_ProductKey.SplitPizza({
                    parts: parts,
                    size: key.value0.size,
                    panType: key.value0.panType
                }));
            });
        };
        $tco_done = true;
        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)(key);
    };
    while (!$tco_done) {
        $tco_result = $tco_loop($copy_key);
    };
    return $tco_result;
};
var newtypeCart = {
    Coercible0: function () {
        return undefined;
    }
};
var toPackagingAssignment = function (cart) {
    return Data_Functor.mapFlipped(Data_Functor.functorArray)((Data_Newtype.unwrap()(cart)).packagingContainers)(function (v) {
        return new Data_Tuple_T2.T2(v.value0, Data_Functor.mapFlipped(Data_Functor.functorArray)(v.value1)(function (v1) {
            return v1.containedId;
        }));
    });
};
var toPackagingContainersCost = function (cart) {
    return (Data_Newtype.unwrap()(cart)).packagingContainersCost;
};
var modifyCouponCode = function (couponCode1) {
    return function (v) {
        return {
            products: v.products,
            promotionalItems: v.promotionalItems,
            couponCode: couponCode1,
            extraDiscount: v.extraDiscount,
            packagingContainers: v.packagingContainers,
            packagingContainersCost: v.packagingContainersCost
        };
    };
};
var mkProductItem = function (extendedKey) {
    return function (quantity) {
        return {
            key: extendedKey.key,
            unitPrice: Data_Maybe.Nothing.value,
            errors: Data_Maybe.Nothing.value,
            details: Data_Maybe.Nothing.value,
            quantity: quantity,
            note: extendedKey.note
        };
    };
};
var makeProductItem = function (menuEnv) {
    return function (v) {
        return function (quantity) {
            return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(normalizeProductKey(v.key))(function (key) {
                return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Cart_Pricing.productPrice(menuEnv)(key))(function (v1) {
                    return Control_Bind.bind(Restaumatic_Menu_Query.bindMenuQuery)(Restaumatic_Cart_Detail.productDetails(menuEnv)(key))(function (details) {
                        return Control_Applicative.pure(Restaumatic_Menu_Query.applicativeMenuQuery)({
                            key: key,
                            unitPrice: v1.price,
                            details: new Data_Maybe.Just(details),
                            errors: v1.errors,
                            quantity: quantity,
                            note: v.note
                        });
                    });
                });
            });
        };
    };
};
var updateProductItem = function (menuEnv) {
    return function (productItem) {
        return makeProductItem(menuEnv)({
            key: Restaumatic_Cart_ProductItem.productItemKey(productItem),
            note: Restaumatic_Cart_ProductItem.productItemNote(productItem)
        })(Restaumatic_Cart_ProductItem.productItemQuantity(productItem));
    };
};
var lookupQuantity = function (needle) {
    var $300 = Data_Maybe.fromMaybe(Data_Numeric.zero(Data_Numeric.additiveInt));
    var $301 = Data_Foldable.findMap(Data_Foldable.foldableArray)(function (v) {
        var $212 = Data_Eq.eq(Restaumatic_Cart_ProductKey.eqProductKey)(v.key)(needle.key) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(v.note)(needle.note);
        if ($212) {
            return new Data_Maybe.Just(v.quantity);
        };
        return Data_Maybe.Nothing.value;
    });
    return function ($302) {
        return $300($301($302));
    };
};
var lookupProduct = function (needle) {
    return Data_Foldable.findMap(Data_Foldable.foldableArray)(function (v) {
        var $217 = Data_Eq.eq(Restaumatic_Cart_ProductKey.eqProductKey)(v.key)(needle);
        if ($217) {
            return new Data_Maybe.Just(v);
        };
        return Data_Maybe.Nothing.value;
    });
};
var itemCount = function (v) {
    return Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Numeric.additiveInt)(Restaumatic_UnwrapOperators.mapUnwrap(Data_Functor.functorArray)()(function (v1) {
        return v1.quantity;
    })(v.products));
};
var isEmpty = function (v) {
    return Data_Array["null"](v.products);
};
var hasSelectedPromotion = function (v) {
    return function (predicate) {
        return Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function (item) {
            return predicate(item) && Restaumatic_Cart_PromotionalItem.promotionalItemSelected(item);
        })(v.promotionalItems);
    };
};
var hasNoErrors = /* #__PURE__ */ (function () {
    var $303 = Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Restaumatic_Cart_ProductItem.hasNoProductErrors);
    return function ($304) {
        return $303(productItems($304));
    };
})();
var groupBy = function (dictOrd) {
    return function (keyFn) {
        return Data_Functor.map(Data_Functor.functorFn)(Data_Map_Internal.fromFoldableWith(dictOrd)(Data_Foldable.foldableArray)(Data_Function.flip(Data_Semigroup.append(Data_Semigroup.semigroupArray))))(Data_Functor.map(Data_Functor.functorArray)(function (x) {
            return new Data_Tuple.Tuple(keyFn(x), [ x ]);
        }));
    };
};
var groupedRightZipWith = function (dictOrd) {
    return function (keyA) {
        return function (keyB) {
            return function (fn) {
                return function (as) {
                    var step = function (v) {
                        return function (b) {
                            var v1 = takeByKey(dictOrd)(keyB(b))(v.value0);
                            if (v1 instanceof Data_Maybe.Nothing) {
                                return new Data_Tuple.Tuple(v.value0, Data_Array.snoc(v.value1)(fn(Data_Maybe.Nothing.value)(v.value1)(b)));
                            };
                            if (v1 instanceof Data_Maybe.Just) {
                                return new Data_Tuple.Tuple(v1.value0.accum, Data_Array.snoc(v.value1)(fn(new Data_Maybe.Just(v1.value0.value))(v.value1)(b)));
                            };
                            throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 577, column 5 - line 581, column 55): " + [ v1.constructor.name ]);
                        };
                    };
                    var $305 = Data_Foldable.foldl(Data_Foldable.foldableArray)(step)(new Data_Tuple.Tuple(groupBy(dictOrd)(keyA)(as), [  ]));
                    return function ($306) {
                        return Data_Tuple.snd($305($306));
                    };
                };
            };
        };
    };
};
var restoreSelections = /* #__PURE__ */ (function () {
    var copySelection = function (from) {
        return function (itemsSoFar) {
            return function (newItem0) {
                var newItem1 = Data_Newtype.wrap()((function () {
                    var v = Data_Newtype.unwrap()(newItem0);
                    var $231 = {};
                    for (var $232 in v) {
                        if ({}.hasOwnProperty.call(v, $232)) {
                            $231[$232] = v[$232];
                        };
                    };
                    $231.input = (Data_Newtype.unwrap()(from)).input;
                    return $231;
                })());
                var v = (Data_Newtype.unwrap()(from)).selection;
                if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.UserEnabled) {
                    return Data_Maybe.fromMaybe(newItem1)(Restaumatic_PromotionsEngine_Tools_UserAction["maybeEnablePromotionalItem$prime"](Restaumatic_Cart_ProductKey.ordProductKey)(itemsSoFar)(newItem1));
                };
                if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.UserDisabled) {
                    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setSelection(Restaumatic_PromotionsEngine_Cart_PromotionalItem.mkUserDisabled)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.unassign(Restaumatic_Cart_ProductKey.ordProductKey)(newItem1));
                };
                return newItem1;
            };
        };
    };
    var maybeCopySelection = function (v) {
        return function (itemsSoFar) {
            return function (v1) {
                if (v instanceof Data_Maybe.Just) {
                    return copySelection(v.value0)(itemsSoFar)(v1);
                };
                if (v instanceof Data_Maybe.Nothing) {
                    var promotionType = (Data_Newtype.unwrap()((Data_Newtype.unwrap()(v1)).promotion)).promotionType;
                    var $240 = Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionType)(promotionType)(Restaumatic_PromotionsEngine_Promotions_Promotion.RequiresCoupon.value);
                    if ($240) {
                        return Data_Maybe.fromMaybe(v1)(Restaumatic_PromotionsEngine_Tools_UserAction["maybeEnablePromotionalItem$prime"](Restaumatic_Cart_ProductKey.ordProductKey)(itemsSoFar)(v1));
                    };
                    return v1;
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 529, column 3 - line 529, column 82): " + [ v.constructor.name, itemsSoFar.constructor.name, v1.constructor.name ]);
            };
        };
    };
    return groupedRightZipWith(Data_Ord.ordInt)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId)(maybeCopySelection);
})();
var genericCart = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCart = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCart)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "couponCode";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "extraDiscount";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "packagingContainers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "packagingContainersCost";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "products";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionalItems";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Cart_PromotionalItem.showPromotionalItem)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Cart_ProductItem.showProductItem)))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Data_Tuple.showTuple(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(/* #__PURE__ */ Data_Show.showArray(/* #__PURE__ */ Restaumatic_Menu_V2_Packaging.showContained(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Orders_Checkout_Types_ExtraDiscount.showExtraDiscount)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "Cart";
        }
    }))
};
var extraDiscountDetails = function (cart) {
    return Data_Functor.map(Data_Maybe.functorMaybe)(function (d) {
        return Restaumatic_Cart_ExtraDiscount.toDetails(d)({
            totalAfterPromotions: totalAfterPromotions(cart)
        });
    })((Data_Newtype.unwrap()(cart)).extraDiscount);
};
var extraDiscount = function (v) {
    return v.extraDiscount;
};
var enginePromotionalItems = function (v) {
    return Data_Functor.map(Data_Functor.functorArray)(promotionsEngineItem)(v.promotionalItems);
};
var emptyItems = function (v) {
    return {
        products: [  ],
        promotionalItems: [  ],
        couponCode: v.couponCode,
        extraDiscount: v.extraDiscount,
        packagingContainers: v.packagingContainers,
        packagingContainersCost: v.packagingContainersCost
    };
};
var empty = /* #__PURE__ */ (function () {
    return {
        products: [  ],
        promotionalItems: [  ],
        couponCode: Data_Maybe.Nothing.value,
        extraDiscount: Data_Maybe.Nothing.value,
        packagingContainers: [  ],
        packagingContainersCost: Data_Numeric.zero(Data_Money_Rounded.additiveMoney)
    };
})();
var distinctProductItems = productItems;
var couponCode = function (v) {
    return v.couponCode;
};
var canOrder = /* #__PURE__ */ (function () {
    var $307 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
    return function ($308) {
        return $307(isEmpty($308));
    };
})();
var baseTotal = function (cart) {
    var subtotal = totalAfterPromotions(cart);
    var extraDiscountValue = Data_Maybe.maybe(Data_Numeric.zero(Data_Money_Rounded.additiveMoney))(function (v) {
        return v.value;
    })(extraDiscountDetails(cart));
    return Data_Numeric.sub(Data_Money_Rounded.additiveMoney)(subtotal)(extraDiscountValue);
};
var applyPromotions = function (mFulfillmentMethod) {
    return function (assignmentMode) {
        return function (menu) {
            return function (assignPromotions$prime) {
                return function (cart) {
                    if (isEmpty(cart)) {
                        return emptyItems(cart);
                    };
                    if (Data_Boolean.otherwise) {
                        var promotions = Restaumatic_Cart_PromotionData.enginePromotions(menu)(mFulfillmentMethod);
                        var cartData = toInputCartData(assignmentMode)(cart);
                        var items = toPromotionalItems(menu)(cartData)(Restaumatic_PromotionsEngine_Cart_CartData.promotionalItems(Restaumatic_PromotionsEngine_Tools_CartEvaluation.evaluateCart(cartData)(assignPromotions$prime(cartData)(Restaumatic_PromotionsEngine_Tools_Distribution.distributePromotions(Restaumatic_Cart_ProductKey.ordProductKey)(cartData)(Restaumatic_PromotionsEngine_Tools_Filter.filterPromotions(cartData)(promotions))))));
                        return setPromotionalItems(items)(cart);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 359, column 1 - line 359, column 111): " + [ mFulfillmentMethod.constructor.name, assignmentMode.constructor.name, menu.constructor.name, assignPromotions$prime.constructor.name, cart.constructor.name ]);
                };
            };
        };
    };
};
var fromProductItems = function (mFulfillmentMethod) {
    return function (assignmentMode) {
        return function (menu) {
            return function (assignPromotions$prime) {
                return function (items) {
                    return function (couponCode1) {
                        var v = packageProductItems(menu)(items);
                        return applyPromotions(mFulfillmentMethod)(assignmentMode)(menu)(assignPromotions$prime)({
                            products: items,
                            promotionalItems: [  ],
                            couponCode: couponCode1,
                            extraDiscount: Data_Maybe.Nothing.value,
                            packagingContainers: v.value0,
                            packagingContainersCost: v.value1
                        });
                    };
                };
            };
        };
    };
};
var alterCount = function (f) {
    return function (insertPos) {
        return function (extendedKey) {
            return function (products) {
                var updateQuantity = function (v) {
                    if (Data_Eq.eq(Restaumatic_Cart_ProductKey.eqProductKey)(v.key)(extendedKey.key) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(v.note)(extendedKey.note)) {
                        var newQuantity = f(v.quantity);
                        var $256 = newQuantity > 0;
                        if ($256) {
                            return new Data_Maybe.Just({
                                key: v.key,
                                unitPrice: v.unitPrice,
                                errors: v.errors,
                                details: v.details,
                                quantity: newQuantity,
                                note: v.note
                            });
                        };
                        return Data_Maybe.Nothing.value;
                    };
                    return new Data_Maybe.Just(v);
                };
                var insertAt = function (v) {
                    if (v instanceof First) {
                        return Data_Array.cons;
                    };
                    if (v instanceof Last) {
                        return Data_Function.flip(Data_Array.snoc);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 663, column 3 - line 663, column 66): " + [ v.constructor.name ]);
                };
                var v = lookupQuantity(extendedKey)(products);
                if (v === 0) {
                    var count = f(0);
                    var $259 = count > 0;
                    if ($259) {
                        return insertAt(insertPos)(mkProductItem(extendedKey)(count))(products);
                    };
                    return products;
                };
                return Data_Array.mapMaybe(updateQuantity)(products);
            };
        };
    };
};
var alterKey = function (oldKey) {
    return function (newKey) {
        return function (products) {
            var replaceKey = function (v) {
                if (Data_Eq.eq(Restaumatic_Cart_ProductKey.eqProductKey)(v.key)(oldKey.key) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(v.note)(oldKey.note)) {
                    return {
                        key: newKey.key,
                        unitPrice: v.unitPrice,
                        errors: v.errors,
                        details: v.details,
                        quantity: v.quantity,
                        note: newKey.note
                    };
                };
                return v;
            };
            var v = lookupQuantity(newKey)(products);
            if (v === 0) {
                return Data_Functor.map(Data_Functor.functorArray)(replaceKey)(products);
            };
            return alterCount(function (v1) {
                return Data_Numeric.add(Data_Numeric.additiveInt)(v1)(v);
            })(Last.value)(newKey)(alterCount(Data_Function["const"](0))(Last.value)(oldKey)(products));
        };
    };
};
var modifyQuantity = function (key) {
    return function (modifyQty) {
        return function (v) {
            var modifyQty$prime = (function () {
                var $309 = Data_Ord.min(Data_Ord.ordInt)(99);
                return function ($310) {
                    return $309(modifyQty($310));
                };
            })();
            return {
                products: alterCount(modifyQty$prime)(First.value)(key)(v.products),
                promotionalItems: v.promotionalItems,
                couponCode: v.couponCode,
                extraDiscount: v.extraDiscount,
                packagingContainers: v.packagingContainers,
                packagingContainersCost: v.packagingContainersCost
            };
        };
    };
};
var applyActionWithAssignMode = function (assignmentMode) {
    return function (action) {
        return function (menu) {
            return function (menuEnv) {
                return function (cart) {
                    var autoEnable = function (v) {
                        if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.CouponCodeInput) {
                            return true;
                        };
                        return false;
                    };
                    var applyPackaging = function (v) {
                        var v1 = packageProductItems(menu)(v.products);
                        return {
                            products: v.products,
                            promotionalItems: v.promotionalItems,
                            couponCode: v.couponCode,
                            extraDiscount: v.extraDiscount,
                            packagingContainers: v1.value0,
                            packagingContainersCost: v1.value1
                        };
                    };
                    var unwrapCart = function (v) {
                        return v;
                    };
                    var promotionalItems1 = (unwrapCart(cart)).promotionalItems;
                    var mFulfillmentMethod = Restaumatic_Menu_V2_Env.fulfillmentMethod(menuEnv);
                    var inputCartData = toInputCartData(assignmentMode)(cart);
                    var setPromotionalItems$prime$prime = function (newItems) {
                        return function (c) {
                            return setPromotionalItems(toPromotionalItems(menu)(inputCartData)(newItems))(c);
                        };
                    };
                    var setPromotionalItems$prime = function (newItems) {
                        return setPromotionalItems$prime$prime(newItems)(cart);
                    };
                    var engineItems = enginePromotionalItems(cart);
                    var doApplyPromotions = applyPromotions(mFulfillmentMethod)(assignmentMode)(menu)(function (inputCartData$prime) {
                        var $311 = Restaumatic_PromotionsEngine_Tools_Assignment.assignPromotionalItems(Restaumatic_Cart_ProductKey.ordProductKey)(inputCartData$prime);
                        var $312 = restoreSelections(engineItems);
                        return function ($313) {
                            return $311($312($313));
                        };
                    });
                    var doApplyMenu = function (v) {
                        return {
                            products: Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)((function () {
                                var $314 = Restaumatic_Menu_Query.runMenuQuery(menu);
                                var $315 = updateProductItem(menuEnv);
                                return function ($316) {
                                    return Data_Either.hush($314($315($316)));
                                };
                            })())(v.products)),
                            promotionalItems: v.promotionalItems,
                            couponCode: v.couponCode,
                            extraDiscount: v.extraDiscount,
                            packagingContainers: v.packagingContainers,
                            packagingContainersCost: v.packagingContainersCost
                        };
                    };
                    if (action instanceof ModifyQuantity) {
                        return applyPackaging(doApplyPromotions(doApplyMenu(modifyQuantity(action.value0)(action.value1)(cart))));
                    };
                    if (action instanceof ReplaceItem) {
                        return applyPackaging(doApplyPromotions(doApplyMenu((function () {
                            var v = Data_Newtype.unwrap()(cart);
                            return {
                                products: alterKey(action.value0)(action.value1)((Data_Newtype.unwrap()(cart)).products),
                                promotionalItems: v.promotionalItems,
                                couponCode: v.couponCode,
                                extraDiscount: v.extraDiscount,
                                packagingContainers: v.packagingContainers,
                                packagingContainersCost: v.packagingContainersCost
                            };
                        })())));
                    };
                    if (action instanceof SetPromotionalItemSelected && action.value1) {
                        return setPromotionalItems$prime(Restaumatic_PromotionsEngine_Tools_UserAction.enablePromotionalItemAndRecalculate(Restaumatic_Cart_ProductKey.ordProductKey)(inputCartData)(engineItems)(promotionsEngineItem(action.value0)));
                    };
                    if (action instanceof SetPromotionalItemSelected && !action.value1) {
                        return setPromotionalItems$prime(Restaumatic_PromotionsEngine_Tools_UserAction.disablePromotionalItemAndRecalculate(Restaumatic_Cart_ProductKey.ordProductKey)(inputCartData)(engineItems)(promotionsEngineItem(action.value0)));
                    };
                    if (action instanceof ChangePromotionalItemInput) {
                        var item$prime = Restaumatic_PromotionsEngine_Cart_PromotionalItem.changeInput(Restaumatic_Cart_ProductKey.eqProductKey)(promotionsEngineItem(action.value0))(action.value1);
                        return setPromotionalItems$prime((function () {
                            var $282 = autoEnable(action.value1);
                            if ($282) {
                                return Restaumatic_PromotionsEngine_Tools_UserAction.enablePromotionalItemAndRecalculate(Restaumatic_Cart_ProductKey.ordProductKey)(inputCartData)(engineItems)(item$prime);
                            };
                            return Restaumatic_PromotionsEngine_Tools_UserAction.updatePromotionalItem(engineItems)(item$prime);
                        })());
                    };
                    if (action instanceof DisablePromotionalItemSelection) {
                        var matching = Data_Array.filter(action.value0)(promotionalItems1);
                        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (cart$prime) {
                            return function (item) {
                                return setPromotionalItems$prime$prime(Restaumatic_PromotionsEngine_Tools_UserAction.disablePromotionalItemAndEvaluate(Restaumatic_Cart_ProductKey.ordProductKey)(toInputCartData(assignmentMode)(cart$prime))(enginePromotionalItems(cart$prime))((Data_Newtype.unwrap()(item)).engineItem))(cart$prime);
                            };
                        })(cart)(matching);
                    };
                    if (action instanceof ModifyCouponCode) {
                        return doApplyPromotions(modifyCouponCode(action.value0)(cart));
                    };
                    if (action instanceof RecalculatePromotions) {
                        return doApplyPromotions(cart);
                    };
                    if (action instanceof RecalculateProductDetails) {
                        return doApplyPromotions(doApplyMenu(cart));
                    };
                    throw new Error("Failed pattern match at Restaumatic.Cart.Cart (line 449, column 5 - line 498, column 47): " + [ action.constructor.name ]);
                };
            };
        };
    };
};
var applyAction = /* #__PURE__ */ (function () {
    return applyActionWithAssignMode(Restaumatic_PromotionsEngine_Cart_CartParams.AutoAssign.value);
})();
var applyActionManualAssign = /* #__PURE__ */ (function () {
    return applyActionWithAssignMode(Restaumatic_PromotionsEngine_Cart_CartParams.ManualAssign.value);
})();
export {
    empty,
    fromProductItems,
    ModifyQuantity,
    ReplaceItem,
    SetPromotionalItemSelected,
    ChangePromotionalItemInput,
    DisablePromotionalItemSelection,
    ModifyCouponCode,
    RecalculatePromotions,
    RecalculateProductDetails,
    applyAction,
    applyActionManualAssign,
    applyActionWithAssignMode,
    setExtraDiscount,
    productItems,
    distinctProductItems,
    promotionalItems,
    couponCode,
    baseTotal,
    isEmpty,
    canOrder,
    itemCount,
    hasSelectedPromotion,
    extraDiscount,
    extraDiscountDetails,
    lookupProduct,
    promotionsTotal,
    makeProductItem,
    normalizeProductKey,
    hasNoErrors,
    toPackagingAssignment,
    toPackagingContainersCost,
    genericCart,
    newtypeCart,
    showCart
};
export {
    ProductItem,
    hasNoProductErrors,
    productItemDetails,
    productItemDishId,
    productItemErrors,
    productItemKey,
    productItemNote,
    productItemPrice,
    productItemQuantity,
    productItemUnitPrice
} from "../Restaumatic.Cart.ProductItem/index.js";
export {
    PromotionalItem,
    promotionalItemAssignment,
    promotionalItemAvailability,
    promotionalItemCouponPromotion,
    promotionalItemDetails,
    promotionalItemEngineItem,
    promotionalItemId,
    promotionalItemInput,
    promotionalItemIsActive,
    promotionalItemPrice,
    promotionalItemPromotion,
    promotionalItemPromotionId,
    promotionalItemSelectable,
    promotionalItemSelected,
    promotionalItemsPartitionCombineable
} from "../Restaumatic.Cart.PromotionalItem/index.js";
//# sourceMappingURL=index.js.map
